/**
 * Đọc hết một danh sách phân trang con trỏ (`{items, next_cursor}`, mục 6.1
 * của đặc tả API).
 *
 * Dùng cho danh sách mà màn hình cần trọn một lần — blocklist nền tảng, đầu mối
 * của một tenant, license, bản cài, hàng chờ duyệt — vì bảng ở đó lọc và sắp
 * phía giao diện. Danh sách dài theo thời gian (nhật ký, thông báo, lịch sử)
 * thì giữ phân trang thật, đừng đi qua đây.
 *
 * Hàm thuần: nhận hàm đọc một trang, không tự gọi HTTP, nên test được bằng dữ
 * liệu nhỏ (`phan-trang.test.ts`).
 */

export interface TrangCon<T> {
  items: T[];
  next_cursor: string | null;
}

/**
 * Trần số trang để một backend trả `next_cursor` lặp không kéo trình duyệt vào
 * vòng vô hạn. 50 trang × 100 dòng là quá mọi danh sách đọc trọn ở trên.
 */
export const SO_TRANG_TOI_DA = 50;

/** Cỡ trang lớn nhất mà các endpoint danh sách nhận (`Limit` của OpenAPI). */
export const CO_TRANG_TOI_DA = 100;

export async function docHetTrang<T>(
  docTrang: (cursor: string | undefined) => Promise<TrangCon<T>>,
  soTrangToiDa: number = SO_TRANG_TOI_DA,
): Promise<T[]> {
  const ra: T[] = [];
  let cursor: string | undefined;
  for (let i = 0; i < soTrangToiDa; i++) {
    const trang = await docTrang(cursor);
    ra.push(...trang.items);
    if (!trang.next_cursor || trang.next_cursor === cursor) return ra;
    cursor = trang.next_cursor;
  }
  return ra;
}
